module.exports = __webpack_public_path__ + "static/greycliffcf-regular-webfont-cccc6a682a8da545c025f510079c96f6.woff";